import { render } from "./insure-team-company.vue?vue&type=template&id=66d13c34&scoped=true&ts=true"
import script from "./insure-team-company.vue?vue&type=script&lang=ts"
export * from "./insure-team-company.vue?vue&type=script&lang=ts"

import "./insure-team-company.vue?vue&type=style&index=0&id=66d13c34&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d13c34"]])

export default __exports__